/** A sub-page heading with a way back, since these sit one level under the Settings tab. */

import { Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";

export function SettingsHeader({
  title,
  description,
}: {
  title: ReactNode;
  description?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <header className="space-y-2">
      <Link
        to="/settings"
        className="-ml-1 inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-800"
      >
        <ChevronLeft className="h-4 w-4" aria-hidden />
        {t("nav.settings")}
      </Link>
      <h1 className="text-xl font-semibold">{title}</h1>
      {description && <p className="text-sm text-stone-600">{description}</p>}
    </header>
  );
}
